<script setup lang="ts">

import { onBeforeUnmount, ref, watch } from 'vue'
import { Auth, Zapin } from '@/services/Api'

const {instance} = defineProps({
    instance: {
        type: Object,
        required: true
    }
})

const token = ref()

Zapin.auth()
    .refreshToken()
    .then((jwt: string) => {
        token.value = jwt
    })
    .catch(() => {
        token.value = Auth.getJwt()
    })

onBeforeUnmount(async () => {
    if (!instance.setup_status) {
        await Zapin
            .instances()
            .show(instance.token)
    }
})

const loading = ref(true)

</script>

<template>
    <div class="bg-white w-full h-full items-center justify-center flex flex-col">
        <div v-if="loading" class="w-full h-full flex justify-center items-center absolute z-10">
            <div class="loader"></div>
        </div>

        <iframe
            class="z-50"
            @load="loading=false"
            allowtransparency="true"
            style="background-color: transparent"
            v-if="instance && token"
            :src="`${instance.configs.wapi.url}/connections/${instance.configs.wapi.token}/?token=${token}`"
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="no"
            allowfullscreen></iframe>
    </div>
</template>

<style scoped>

</style>
